import {GameObjects, Scene} from "phaser";
import {BaseAnimation} from "./BaseAnimation";

export class Coin implements BaseAnimation
{
    private scene;

    constructor (scene: Scene)
    {
        this.scene = scene;
    }

    public loadImages(): void
    {
        //this.scene.load.path = 'assets/coin/';
        this.scene.load.image('coin_1', 'assets/tilesets/coin/coin_1.png');
        this.scene.load.image('coin_2', 'assets/tilesets/coin/coin_2.png');
        this.scene.load.image('coin_3', 'assets/tilesets/coin/coin_3.png');
        this.scene.load.image('coin_4', 'assets/tilesets/coin/coin_4.png');
        this.scene.load.image('coin_5', 'assets/tilesets/coin/coin_5.png');
        this.scene.load.image('coin_6', 'assets/tilesets/coin/coin_6.png');
        this.scene.load.image('coin_7', 'assets/tilesets/coin/coin_7.png');
        this.scene.load.image('coin_8', 'assets/tilesets/coin/coin_8.png');
        this.scene.load.image('raggio_1', 'assets/tilesets/coin/raggio_1.png');
        this.scene.load.image('raggio_2', 'assets/tilesets/coin/raggio_2.png');
        this.scene.load.image('raggio_3', 'assets/tilesets/coin/raggio_3.png');
        this.scene.load.image('coinScore_1', 'assets/tilesets/coinScore/coinScore_1.png');
        this.scene.load.image('coinScore_2', 'assets/tilesets/coinScore/coinScore_2.png');
        this.scene.load.image('coinScore_3', 'assets/tilesets/coinScore/coinScore_3.png');
        this.scene.load.image('coinScore_4', 'assets/tilesets/coinScore/coinScore_4.png');
        this.scene.load.image('coinScore_5', 'assets/tilesets/coinScore/coinScore_5.png');
        this.scene.load.image('coinScore_6', 'assets/tilesets/coinScore/coinScore_6.png');
        this.scene.load.image('coinScore_7', 'assets/tilesets/coinScore/coinScore_7.png');
        this.scene.load.image('coinScore_8', 'assets/tilesets/coinScore/coinScore_8.png');
        this.scene.load.image('coinAirplane','assets/tilesets/coin/coin_1.png');
    }

    public generateFrames(): void
    {
        this.scene.anims.create({
            key: 'coin',
            frames: [
                { key: 'coin_1', frame: null},
                { key: 'coin_2', frame: null},
                { key: 'coin_3', frame: null},
                { key: 'coin_4', frame: null},
                { key: 'coin_5', frame: null},
                { key: 'coin_6', frame: null},
                { key: 'coin_7', frame: null},
                { key: 'coin_8', frame: null, duration:30}
            ],
            frameRate: 5,
            repeat: -1
        });

        this.scene.anims.create({
            key: 'coinScore',
            frames: [
                { key: 'coinScore_1', frame: null},
                { key: 'coinScore_2', frame: null},
                { key: 'coinScore_3', frame: null},
                { key: 'coinScore_4', frame: null},
                { key: 'coinScore_5', frame: null},
                { key: 'coinScore_6', frame: null},
                { key: 'coinScore_7', frame: null},
                { key: 'coinScore_8', frame: null, duration:30}
            ],
            frameRate: 5,
            repeat: -1
        });


        this.scene.anims.create({
            key: 'solarCoin',
            frames: [
                { key: 'raggio_3', frame: null},
                { key: 'raggio_2', frame: null},
                { key: 'raggio_1', frame: null}
            ],
            frameRate: 5,
            repeat: 0
        });



    }

}
